import { useEffect, useState } from "react";

/**
 * Redirects the user to the error page after 20 minutes.
 * It will lock like transaction is expired.
 */
const useExpirationTimer = () => {
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRedirect(true);
    }, 20 * 60 * 1000); // 20 minutes in milliseconds

    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (redirect) {
      window.location.href =
        window.location.href.replace("checkout", "purchase-failed") +
        `&reason=transaction-expired`;
    }
  }, [redirect]);
};

export default useExpirationTimer;
